import { render, staticRenderFns } from "./strategi.vue?vue&type=template&id=f15ff9b2&"
import script from "./strategi.vue?vue&type=script&lang=js&"
export * from "./strategi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports